import { Component, ComponentInterface, h, Prop, VNode } from '@stencil/core';

import { uniWatermark } from '@uni/license';
import { UniTemplate } from '@uiwebkit/common';

@Component({ tag: 'uni-scroll-to' })
export class UniScrollToComponent implements ComponentInterface {

  @Prop({ reflect: true }) inactive: boolean = false;

  @Prop({ mutable: true }) activate: boolean = false;

  @Prop({ reflect: true }) selector!: string;

  @Prop({ reflect: true }) behavior: ScrollBehavior = 'auto';

  @Prop({ reflect: true }) offsetY: number;

  @Prop({ reflect: true }) timeout: number = 100;

  render(): VNode {
    return UniTemplate(<slot />);
  }

  componentDidRender(): void {
    const { behavior } = this;

    if (!this.inactive || this.activate) {
      setTimeout(() => {
        const selected = document.querySelector(this.selector);

        if (this.offsetY) {
          const y = selected?.getBoundingClientRect().top + window.scrollY + this.offsetY;
          window.scrollTo({ top: y, behavior });
        } else {
          selected.scrollIntoView({ behavior });
        }
      }, this.timeout);

      setTimeout(() => this.activate = false);
    }
  }

  componentDidLoad(): void {
    uniWatermark('pro');
  }
}
